import { PayloadType } from 'store/dashboard';
import { CustomOverlayType, EventsType } from '.';
import {
	DISMISSED_ASYNC_EVENT_FAILURE,
	DISMISSED_ASYNC_EVENT_SUCCESS,
	RECEIVED_MY_SUCCESS_ITEMS,
	RECEIVED_PROGRAM,
	REQUEST_ADD_EVENTS,
	REQUEST_ASYNC_EVENTS,
	REQUEST_ASYNC_EVENTS_FAILURE,
	REQUEST_ASYNC_EVENTS_SUCCESS,
	REQUEST_CUSTOM_OVERLAYS,
	REQUEST_CUSTOM_OVERLAYS_FAILURE,
	REQUEST_CUSTOM_OVERLAYS_SUCCESS,
	REQUEST_FLUSH_EVENT_BY_IDS,
	REQUEST_FLUSH_EVENTS,
	REQUEST_FLUSH_EVENTS_BY_TYPE_ID,
	REQUEST_SAVE_CUSTOM_OVERLAY_SHOWN,
} from './events.actionTypes';

export const actionCreators = {
	doAddEvents: (events: EventsType) => ({
		type: REQUEST_ADD_EVENTS,
		events,
	}),
	doFlushEventsByTypeAndId: (eventType: string, reactId: string) => ({
		type: REQUEST_FLUSH_EVENTS_BY_TYPE_ID,
		eventType,
		reactId,
	}),
	doFlushEventByIds: (reactIds: string[]) => ({
		type: REQUEST_FLUSH_EVENT_BY_IDS,
		reactIds,
	}),
	doFlushEvents: () => ({
		type: REQUEST_FLUSH_EVENTS,
	}),
	doRequestAsyncEvents: () => ({
		type: REQUEST_ASYNC_EVENTS,
	}),
	doReceiveAsyncEvents: (events: EventsType) => ({
		type: REQUEST_ASYNC_EVENTS_SUCCESS,
		events,
	}),
	doReceiveAsyncEventsFailure: (error: any) => ({
		type: REQUEST_ASYNC_EVENTS_FAILURE,
		error,
	}),
	doAsyncEventDismissed: (id: string | number) => ({
		type: DISMISSED_ASYNC_EVENT_SUCCESS,
		id,
	}),
	doAsyncEventNotDismissed: (error: any) => ({
		type: DISMISSED_ASYNC_EVENT_FAILURE,
		error,
	}),
	doRequestCustomOverlays: () => ({
		type: REQUEST_CUSTOM_OVERLAYS,
	}),

	doSaveCustomOverlayShown: (id: string) => ({
		type: REQUEST_SAVE_CUSTOM_OVERLAY_SHOWN,
		id,
	}),
	doReceiveCustomOverlays: (customOverlays: CustomOverlayType[]) => ({
		type: REQUEST_CUSTOM_OVERLAYS_SUCCESS,
		customOverlays,
	}),
	doReceiveCustomOverlaysFailure: (error: any) => ({
		type: REQUEST_CUSTOM_OVERLAYS_FAILURE,
		error,
	}),
	doReceivedProgram: (payload: PayloadType) => ({
		type: RECEIVED_PROGRAM,
		payload,
	}),
	doRequestMySuccessSuccess: (contents: any) => ({
		type: RECEIVED_MY_SUCCESS_ITEMS,
		contents,
	}),
};

export type EventsActionType =
	| ReturnType<typeof actionCreators.doAddEvents>
	| ReturnType<typeof actionCreators.doFlushEventsByTypeAndId>
	| ReturnType<typeof actionCreators.doFlushEventByIds>
	| ReturnType<typeof actionCreators.doFlushEvents>
	| ReturnType<typeof actionCreators.doRequestAsyncEvents>
	| ReturnType<typeof actionCreators.doReceiveAsyncEvents>
	| ReturnType<typeof actionCreators.doReceiveAsyncEventsFailure>
	| ReturnType<typeof actionCreators.doAsyncEventDismissed>
	| ReturnType<typeof actionCreators.doAsyncEventNotDismissed>
	| ReturnType<typeof actionCreators.doRequestCustomOverlays>
	| ReturnType<typeof actionCreators.doReceiveCustomOverlays>
	| ReturnType<typeof actionCreators.doReceiveCustomOverlaysFailure>
	| ReturnType<typeof actionCreators.doReceivedProgram>
	| ReturnType<typeof actionCreators.doRequestMySuccessSuccess>;
